var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row no-gutters h-100"},[_c('div',{staticClass:"col-10 offset-1 col-lg-12 offset-lg-0"},[_c('div',{staticClass:"row no-gutters align-items-center h-100 justify-content-center"},[_c('app-type-activity')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }